import styles from './DashboardLogo.module.css';

import logo from '../../../assets/images/logos/smart-tutor_logo.svg';

export const DashboardLogo = () => {
    return <div className={styles.logo}>
        <img src={logo} alt="SMART TUTOR"/>
    </div>
}